import React,{useState,useEffect} from 'react'
import { Link } from 'react-router-dom';
// import { useGlobalContext } from '../context';


const IMGPATH = "https://image.tmdb.org/t/p/w1280";

const Movielist = ({id,title,poster_path,overview,vote_average}) => {
    // const {search} = useGlobalContext()
    const [showOverView,setShowOverView] = useState(false)
    const imgRef = React.useRef()
    
    const displayOverview = () =>{
        setShowOverView(true)
    }

    const noOverview = () =>{
        setShowOverView(false)
    } 
    
    useEffect(()=>{
        imgRef.current.addEventListener('mouseover',displayOverview)
    },[])

    useEffect(()=>{
        imgRef.current.addEventListener('mouseout',noOverview)
    },[])
    return (
        <>
            <div ref={imgRef} className="movie_item">
                <div className="img_container" id="id">
                <Link to={`movies/${id}`}><img src={IMGPATH + poster_path} alt={title} /></Link>
                <div className={showOverView ? 'overview' : 'overview_none'}>
                    <p>{overview.substring(0,300)}...</p>
                </div>
                </div>
                <div className="movie_info">
                    <div>
                    <h3 className='title'>{title}</h3>
                    </div>
                    <div>
                    <p className='rating'>{vote_average}</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Movielist
